module.exports = __webpack_public_path__ + "hyperion-v2-static/fonts/TruenoBlk.765ce4cb.otf";